export const themes = {
  default: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16',
  },
  column: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16',
  },
  inline: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16',
  },
};
